import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const intents = [
  {
    emoji: "🚀",
    label: "I need a job fast",
    link: "/career-quiz?goal=job",
    color: "border-l-primary",
  },
  {
    emoji: "💰",
    label: "I want to earn while learning",
    link: "/career-quiz?goal=earn-learn",
    color: "border-l-secondary",
  },
  {
    emoji: "😟",
    label: "I'm confused — help me decide",
    link: "/career-quiz",
    color: "border-l-purple-500",
  },
  {
    emoji: "🏛️",
    label: "I want a government job",
    link: "/career-quiz?goal=govt",
    color: "border-l-blue-500",
  },
];

export const QuickEntrySection = () => {
  return (
    <section className="py-8 bg-background">
      <div className="container">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-4xl mx-auto">
          {intents.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.06 }}
            >
              <Link
                to={item.link}
                className={`block p-4 rounded-xl bg-card border border-border ${item.color} border-l-4 hover:shadow-card transition-all text-center group`}
              >
                <span className="text-2xl block mb-2">{item.emoji}</span>
                <span className="text-sm font-semibold text-foreground group-hover:text-primary transition-colors">
                  {item.label}
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
